var app = angular.module('leonardo');

var FloatFormat = function () {
  return {
    restrict: 'A',
    require: ['ngModel'],
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.fractionSize = !isNull(attrs.fractionSize) ? parseInt(attrs.fractionSize) : 5;

      scope.ngModelCtrl.$render = function() {
        if (!isNull(scope.ngModelCtrl.$modelValue)) {
          var comma_array = scope.ngModelCtrl.$modelValue.toString().split(',');
          if (comma_array.length > 1) {
            scope[attrs.ngModel] = parseFloat(comma_array.join('.'));
          }
          else {
            scope[attrs.ngModel] = parseFloat(scope.ngModelCtrl.$modelValue);
          }
        }
        else {
          scope[attrs.ngModel] = scope.ngModelCtrl.$modelValue;
        }
      };

      scope.$watch(attrs.ngModel, function(newValue) {
        var val = element.val();
        if (!isNull(val) && !isNull(newValue)) {
          if ((val[0] === '.')) {
            val = '0' + val;
          }
          else if ((val.length > 1) && (val[0] === '-') && (val[1] === '.')) {
            val = '-0.' + val.slice(2,val.length - 1);
          }
          element.val(val);
          var result = isNaN(parseFloat(val)) ? null : parseFloat(val);
          scope.ngModelCtrl.$setViewValue(result);
        }
        else {
          if (isNull(newValue) && scope.ngModelCtrl.$modelValue !== undefined) {
            element.val('');
            scope.ngModelCtrl.$setViewValue(null);
          }
          else {
            element.val(newValue);
            scope.ngModelCtrl.$setViewValue(newValue);
          }
        }
        scope.ngModelCtrl.$render();
      });


      scope.setInputFilter = function (textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
          textbox.addEventListener(event, function() {
            if (inputFilter(this.value)) {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
          });
        });
      };

      scope.setInputFilter(element[0], function(value) {
        return /^-?\d*(?:\.\d*)?$/u.test(value);
      });

      element.on("keydown keypress", function (e) {
        if (!_.contains([8, 13, 46], e.keyCode)) {
          var decimal_array = !isNull(this.value) ? this.value.split('.') : [];
          if (decimal_array.length > 1) {
            if (decimal_array[1].length >= scope.fractionSize) {
              e.preventDefault();
            }
          }
        }
      });
    }
  };
};

app.directive('floatFormat', [FloatFormat]);